"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var App_1 = require("./App");
var ConfigContext_1 = require("./contexts/ConfigContext");
window.addEventListener('DOMContentLoaded', function (event) {
    window.parent.postMessage(JSON.stringify({ action: 'init' }), "*");
    window.removeEventListener('DOMContentLoaded', function () { return null; });
});
window.addEventListener('message', function (event) {
    event.preventDefault();
    if (!event.data || (typeof event.data !== 'string'))
        return;
    var config = JSON.parse(event.data);
    return preact_1.render(preact_1.h(ConfigContext_1.default.Provider, { value: config },
        preact_1.h(App_1.default, null)), document.body);
});
